import React from 'react';
import smoothScroll from 'smoothscroll';
import { v4 as uuidv4 } from 'uuid';

import submitForm from './helpers/SubmitForm';

import sourceItems from './sources/Items';

import Hero from './components/Hero';
import Question from './components/Question';
import Questionnaire from './components/Questionnaire';
import Thanks from './components/Thanks';
import Terms from './components/Terms';
import Footer from './components/Footer';

import './styles/App.scss';

class App extends React.Component {
  static scrollTo(id) {
    const targetSelector = document.querySelector(id);

    if (targetSelector === null) {
      /* eslint-disable-next-line */
      console.warn('Could not scrollTo, selector not found!');

      return;
    }

    smoothScroll(document.querySelector(id));
  }

  constructor(props) {
    super(props);

    this.state = {
      error: null,
      isLoading: true,
      isSending: false,
      isSent: false,
      isTermsOpen: false,
      questions: [],
      selectedItems: [],
    };

    this.onSelectItem = this.onSelectItem.bind(this);
    this.onSubmitForm = this.onSubmitForm.bind(this);
  }

  componentDidMount() {
    try {
      this.setState({
        questions: sourceItems,
        isLoading: false,
      });
    } catch (error) {
      this.setState({
        error,
        isLoading: false,
      });
    }
  }

  onSelectItem(id, siblingItems) {
    const { selectedItems } = this.state;

    // If current item is selected, remove it from selectedItems
    const isSelected = selectedItems.includes(id);

    if (isSelected) {
      this.setState({
        selectedItems: selectedItems.filter((item) => item !== id),
      });

      return;
    }

    // If current items is not selected, add it to selectedItems and remove siblings
    const filteredSelectedItems = selectedItems
      .filter((item) => !siblingItems.includes(item));

    this.setState({
      selectedItems: [...filteredSelectedItems, id],
    });
  }

  onSubmitForm(url, data) {
    this.setState({
      isSending: true,
    });

    submitForm(url, data)
      .then(() => {
        App.scrollTo('#thx');

        this.setState({
          isSending: false,
          isSent: true,
        });
      })
      .catch((error) => {
        this.setState({
          error,
          isSending: false,
          isSent: false,
        });
      });
  }

  toggleTerms() {
    const { isTermsOpen } = this.state;

    if (!isTermsOpen) {
      App.scrollTo('#terms');
    }

    this.setState({
      isTermsOpen: !isTermsOpen,
    });
  }

  render() {
    const {
      error,
      isLoading,
      isSending,
      isSent,
      isTermsOpen,
      questions,
      selectedItems,
    } = this.state;

    if (error) {
      return (
        <div className="app">
          <div className="full-screen-wrap error-wrap">
            <h2 className="h2">
              Tapahtui virhe. Ole hyvä ja lataa sivu uudestaan.
            </h2>
          </div>
        </div>
      );
    }

    if (isLoading) {
      return (
        <div className="app">
          <div className="full-screen-wrap loading-wrap">
            <h2 className="h2">
              Äänestystä ladataan...
            </h2>
          </div>
        </div>
      );
    }

    return (
      <div className="app">
        <div className="content">
          <Hero scrollTo={App.scrollTo} />
          <div id="thx">
            {!isSending && !isSent ? (
              <>
                <ul
                  className="list questions"
                  id="competition"
                >
                  {questions.map((questionItem) => (
                    <li
                      className="question-item"
                      key={uuidv4()}
                    >
                      <Question
                        isSending={isSending}
                        onSelectItem={this.onSelectItem}
                        question={questionItem}
                        selectedItems={selectedItems}
                      />
                    </li>
                  ))}
                </ul>
                <Questionnaire
                  isSending={isSending}
                  onSubmitForm={this.onSubmitForm}
                  selectedItems={selectedItems}
                  toggleTerms={() => this.toggleTerms()}
                />
                <Terms
                  isTermsOpen={isTermsOpen}
                  toggleTerms={() => this.toggleTerms()}
                />
              </>
            ) : null}
            {isSending ? (
              <div className="is-sending">
                <h2 className="h2">
                  Lähetetään...
                </h2>
              </div>
            ) : null}
            {isSent ? (
              <Thanks
                selectedItems={selectedItems}
                sourceItems={sourceItems}
              />
            ) : null}
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default App;
